// extracted by mini-css-extract-plugin
export default {"pill":"SyncStatus_pill__cqmAJ","ok":"SyncStatus_ok__HSBSG","syncing":"SyncStatus_syncing__w4e74","offline":"SyncStatus_offline__GYNEn"};